import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";

// Material Kit 2 React examples
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

//import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
//import Pages from "pages/Presentation/sections/Pages";
//import Testimonials from "pages/Presentation/sections/Testimonials";
//import Download from "pages/Presentation/sections/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";
import React from "react";
// Routes
//import routes from "routes";
// Images
import bgImage from "assets/images/strategia.jpg";

/* eslint-disable react/prop-types */
const Scraping = () => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  return (
    <>
      <MKBox
        minHeight="23vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "2500px 500px",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      />
      <MKBox pt={6} px={1} mt={6}>
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="h1"
              color="black"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              Listojen lukeminen{" "}
            </MKTypography>
            <MKTypography
              variant="body1"
              color="black"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              Tutustu ja osallistu kotikuntasi päätöksenteossa käsiteltäviin asioihin.
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
    </>
  );
};

export default Scraping;
